<script>

  import SgsRenderInputData from './SgsRenderInputData.vue';
  import utils from 'src/app/module/FormBuilderUtils.js';
  import moduleUtils from 'src/app/module/ModuleUtils';

  export default {
    props: [
      "attr", "fieldValue", "formIdentifier", "rules",
      "label", "showHint", "hintValue", "placeholder",
      "instance", "moduleType", "disableField"
    ],
    data() {
      return {
        attr_copy: ""
      }
    },
    components: {
      SgsRenderInputData
    },
    mounted: function() {

      let formIdentifier = Object.assign({}, this.formIdentifier, {formId: this.attr.formId});

      moduleUtils.resolveModuleDescription(formIdentifier).then(response => {
        let fields = response.fieldDesc.fields;

        this.attr_copy = Object.assign({}, this.attr);
        this.attr_copy.uri = moduleUtils.resolveFormUri(formIdentifier) + "/autocomplete";

        if (this.attr_copy.uriFilterList) {

          let uriFilterList = this.attr_copy.uriFilterList.slice();
          this.attr_copy.uriFilterList = []

          uriFilterList.map(it => {
            let field = utils.findField(it, fields);
            this.attr_copy.uriFilterList.push(field.columnName);
          });
        }

        if (this.attr_copy.uriFilterListEs) {

          let uriFilterListEs = this.attr_copy.uriFilterListEs.slice();
          this.attr_copy.uriFilterListEs = []

          uriFilterListEs.map(it => {
            let field = utils.findField(it, fields);
            this.attr_copy.uriFilterListEs.push(field.columnName);
          });
        }

        if (this.attr_copy.uriFilterListEn) {

          let uriFilterListEn = this.attr_copy.uriFilterListEn.slice();
          this.attr_copy.uriFilterListEn = []

          uriFilterListEn.map(it => {
            let field = utils.findField(it, fields);
            this.attr_copy.uriFilterListEn.push(field.columnName);
          });
        }

        if (this.attr_copy.columnsToShow) {

          let columnsToShow = this.attr_copy.columnsToShow.slice();
          this.attr_copy.columnsToShow = {};
          this.attr_copy.columnsToShowAttr = {};

          columnsToShow.map(it => {
            let field = utils.findField(it, fields);
            this.attr_copy.columnsToShow[field.columnName] = field.labelPt;
            this.attr_copy.columnsToShowAttr[field.columnName] = field;
          });
        }

        if (this.attr_copy.type == 'association' && this.attr_copy.columnValue) {
          let field = utils.findField(this.attr_copy.columnValue, fields);
          this.attr_copy.columnValueFieldId = this.attr_copy.columnValue;
          this.attr_copy.columnValue = field.columnName;
        }

        if (this.attr_copy.columnLabel) {

          let field = utils.findField(this.attr_copy.columnLabel, fields);
          this.attr_copy.columnLabel = field.columnName;


          if (this.attr_copy.columnLabelEs) {

            let fieldEs = utils.findField(this.attr_copy.columnLabelEs, fields);

            if (fieldEs != undefined) {
              this.attr_copy.columnLabelEs = fieldEs.columnName;

              if (this.attr_copy.columnsToShowEs) {

                let columnsToShowEs = this.attr_copy.columnsToShowEs.slice();
                this.attr_copy.columnsToShowEs = {};
                this.attr_copy.columnsToShowEsAttr = {};

                columnsToShowEs.map(it => {
                  let field = utils.findField(it, fields);
                  this.attr_copy.columnsToShowEs[field.columnName] = field.labelEs;
                  this.attr_copy.columnsToShowEsAttr[field.columnName] = field;
                });
              }
            }
          }

          if (this.attr_copy.columnLabelEn) {

            let fieldEn = utils.findField(this.attr_copy.columnLabelEn, fields);

            if (fieldEn != undefined) {

              this.attr_copy.columnLabelEn = fieldEn.columnName;

              if (this.attr_copy.columnLabelEn) {

                if (fieldEn != undefined) {

                  this.attr_copy.columnLabelEn = fieldEn.columnName;

                  if (this.attr_copy.columnsToShowEn) {

                    let columnsToShowEn = this.attr_copy.columnsToShowEn.slice();
                    this.attr_copy.columnsToShowEn = {};
                    this.attr_copy.columnsToShowEnAttr = {};

                    columnsToShowEn.map(it => {
                      let field = utils.findField(it, fields);
                      this.attr_copy.columnsToShowEn[field.columnName] = field.labelEn;
                      this.attr_copy.columnsToShowEnAttr[field.columnName] = field;
                    });
                  }
                }
              }
            }
          }
        }
      });
    },
    computed: {
      updateFieldValue: {
        get: function() {
          return this.fieldValue;
        },
        set: function(newValue) {
          this.$emit('input', newValue);
        }
      }
    },
    methods: {
      callBusinessRule: function(BusinessRuleId) {
        this.$emit('callBusinessRule', BusinessRuleId);
      }
    }
  }
</script>

<style scopde>
  input {
    background-color: white !important;
  }
</style>

<template>
  <SgsRenderInputData
    v-if="attr_copy != ''"
    :attr="attr_copy"
    :fieldValue="fieldValue"
    v-model="updateFieldValue"
    :rules="rules"
    :showHint="showHint"
    :label="label"
    :hintValue="hintValue"
    :moduleType="moduleType"
    :placeholder="placeholder"
    :instance="instance"
    :formIdentifier="formIdentifier"
    :attrOriginal="attr"
    @callBusinessRule="callBusinessRule"
    :disableField="disableField"
  />
</template>



// WEBPACK FOOTER //
// SgsRenderInputDataFormWrapper.vue?3e88bb18